
<template>
  <section class="sm-upper">
    <div class="sm-wrap sm">
      <div class="sm-upper__user">
        <div 
          class="sm-upper__user-avatar" 
          @click="$refs.input_file.click()"
        >
          <img-loader 
            v-if="avatar"
            :src="avatar" 
          />
          <include-svg
            v-else
            :name="'icon-no-avatar'"
          />

          <include-svg :name="'icon-edit'" />
          <input 
            ref="input_file"
            hidden 
            type="file" 
            name="image" 
            @change="uploadFile" 
          />
        </div>
        <div class="sm-upper__user-flex">
          <div class="sm-upper__user-flex-row">
            <h4>{{userAccount.first_name}}&nbsp;{{userAccount.last_name}}</h4>
          </div>
          <span 
            v-if="userAccount.company_name"
            class="sm-txt-upper"
          >{{userAccount.company_name}}</span>
        </div>
        <div class="sm-upper__user-col">
          <a 
            href="#"
            class="sm-upper__logout"
            @click.prevent="logOut()"
          >
            <include-svg :name="'icon-logout'" />
            <span>Log out</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import imageStore from '@/utils/image-store';
import {IsRightFileType} from "@/utils/general-data";
import ImgLoader from '@/components/ImgLoader';

export default {
  name: 'account-top',
  components: {
    'img-loader': ImgLoader
  },
  data() {
    return {
      image: ''
    }
  },
  computed: {
    ...mapGetters({
      userAccount: 'account/userAccount'
    }),
    avatar() {
      let path;

      if (this.image) {
        path = this.image;
      } else if (this.userAccount.image_url) {
        path = imageStore(this.userAccount.image_url);
      } else {
        path = null;
      }

      return path;
    }
  },
  methods: {
    ...mapActions({
      updateUser: "account/updateUser",
    }),
    isRightFileType: IsRightFileType,
    logOut() {
      this.$router.push('/login');
    },
    uploadFile(e) {
      if (e.target.files.length === 0) 
        return false;

      const target = e.target;
      const file = target.files[0];

      if (!this.isRightFileType(file, ['image']))
        return false;

      // update account
      let formData = new FormData();
      formData.append('account[image]', file);

      this.updateUser(formData);

      // create poster
      this.image = this.createPoster(file);
    },
    createPoster(file) {
      if (!file) 
        return false;

      const maxWeight = 25165824;

      let size = file.size;

      if (size > maxWeight) 
        return false;

      return URL.createObjectURL(file);
    },
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/customer/account/_upper.scss';
</style>